import { Module } from 'src/domain';
import { useUpdateModuleInheritance } from 'src/hooks/split-levels/useUpdateModuleInheritance';

export const useMarkdownUpdateInheritance = (standalone = true) =>
    useUpdateModuleInheritance(Module.Markdown, standalone);
